var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"previewPage"},_vm._l((_vm.numPages),function(item){return _c('pdf',{key:item,attrs:{"src":_vm.src,"page":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }